import type { FieldErrors } from 'react-hook-form';
import type { SingleValue } from 'react-select';
import { Selector } from '@/app/components/form/Selector';
import type { SelectorOption } from '@/app/components/form/Selector/types';
import type { Nullable } from '@/types/common';

const EMPTY_HELPER_TEXT = 'Email and phone will be synced from the selected passenger.';
const SELECTED_HELPER_TEXT = 'Email and phone are synced from this passenger.';

interface UseContactDetailsFromSelectorProps {
  options: SelectorOption<number>[];
  value: Nullable<number>;
  onChange: (option: SingleValue<SelectorOption<number>>) => void;
  name: string;
  errors?: FieldErrors;
}

export function UseContactDetailsFromSelector({
  options,
  value,
  onChange,
  name,
  errors,
}: UseContactDetailsFromSelectorProps) {
  const hasResolvedSource = options.some((option) => option.value === value);

  return (
    <div className="flex flex-col gap-2">
      <Selector<number>
        label="Use contact details from"
        placeholder="Select primary passenger"
        options={options}
        value={value}
        onChange={onChange}
        isClearOption={false}
        menuPosition="fixed"
        name={name}
        errors={errors}
      />
      <p className="text-body-small text-grey-700">{hasResolvedSource ? SELECTED_HELPER_TEXT : EMPTY_HELPER_TEXT}</p>
    </div>
  );
}
